module.exports = __webpack_public_path__ + "img/teacher-second.11d2a00c.png";